/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type FilterInsuranceQueryVariables = {};
export type FilterInsuranceQueryResponse = {
    readonly planNames: ReadonlyArray<string | null> | null;
};
export type FilterInsuranceQuery = {
    readonly response: FilterInsuranceQueryResponse;
    readonly variables: FilterInsuranceQueryVariables;
};



/*
query FilterInsuranceQuery {
  planNames: insuranceUniquePlanNamesMany(limit: 5000)
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "planNames",
    "args": [
      {
        "kind": "Literal",
        "name": "limit",
        "value": 5000
      }
    ],
    "kind": "ScalarField",
    "name": "insuranceUniquePlanNamesMany",
    "storageKey": "insuranceUniquePlanNamesMany(limit:5000)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterInsuranceQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FilterInsuranceQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "de09918a285ca32958d89ac06ae17ce5",
    "id": null,
    "metadata": {},
    "name": "FilterInsuranceQuery",
    "operationKind": "query",
    "text": "query FilterInsuranceQuery {\n  planNames: insuranceUniquePlanNamesMany(limit: 5000)\n}\n"
  }
};
})();
(node as any).hash = '80f60b2dfee9da23d5513ce2d1afaddd';
export default node;
